import React from 'react';
import { Typography } from '@mui/material';
import { GuideSection } from '../common/GuideSection';
import { GuideSubsection } from '../common/GuideSubsection';
import { StepByStep } from '../common/StepByStep';
import { Tip } from '../common/Tip';
import { useTranslation } from '../../../i18n';

export const DroneNotesSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <GuideSection id="drone-notes" title={t('guide.sections.droneNotes')}>
      <Typography variant="body1" sx={{ mb: 2, color: '#555' }}>
        {t('guide.droneNotes.intro')}
      </Typography>

      <GuideSubsection id="notes-creating" title={t('guide.sections.droneNotesCreating')}>
        <StepByStep
          steps={[
            t('guide.droneNotes.creating.steps.s1'),
            t('guide.droneNotes.creating.steps.s2'),
            t('guide.droneNotes.creating.steps.s3'),
            t('guide.droneNotes.creating.steps.s4'),
            t('guide.droneNotes.creating.steps.s5'),
            t('guide.droneNotes.creating.steps.s6'),
            t('guide.droneNotes.creating.steps.s7'),
          ]}
        />
      </GuideSubsection>

      <GuideSubsection id="notes-filters" title={t('guide.sections.droneNotesFilters')}>
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.droneNotes.filters.description')}
        </Typography>
      </GuideSubsection>

      <GuideSubsection id="notes-timeline" title={t('guide.sections.droneNotesTimeline')}>
        <Typography variant="body1" sx={{ color: '#555' }}>
          {t('guide.droneNotes.timeline.description')}
        </Typography>
        <Tip>{t('guide.droneNotes.timeline.tipDateRange')}</Tip>
      </GuideSubsection>
    </GuideSection>
  );
};
